<script>
export default {
  name: 'ShopBox',
  props: {
    label: String,
    price: Number,
    image: String,
    tag: String
  },
  data () {
    return {
      apiUrl: process.env.VUE_APP_API_URL
    }
  }
}
</script>

<template>
  <router-link :to="'/boutique/' + tag" class="relative w-full md:w-1/3 h-72 flex items-end hover:cursor-pointer box overflow-hidden">
    <img :src="`${apiUrl}${image}`" alt="La brune" class="absolute inset-0 w-full h-full object-cover">
    <div class="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent"></div>
    <div class="w-full h-full absolute bg-black shadow"></div>
    <div class="relative w-full p-5 text-white z-10">
      <h2 class="uppercase font-extrabold text-xl">{{ label }}</h2>
      <h3 class="uppercase font-extrabold text-lg">{{ price }} €</h3>
    </div>
  </router-link>
</template>

<style>
.box {
  position: relative;
  overflow: hidden;
  transition: transform 0.3s ease-in-out;
}

.box h2 {
  position: relative;
  transform: translateY(+20px);
  transition: transform 0.3s ease-in-out;
}
.box h3 {
  transform: translateY(+50px);
  transition: transform 0.3s ease-in-out;
}

.box:hover h2 {
  transform: translateY(0px);
}
.box:hover h3 {
  transform: translateY(0px);
}
.box .shadow {
  opacity: 0;
  transition: opacity 0.3s ease-in-out;
}
.box:hover .shadow {
  opacity: 0.4;
  transition: opacity 0.3s ease-in-out;
}
</style>